import Fetch from "utils/fetch";

export const importMasterdata = (payloadData) =>
  Fetch.put(`/masterdata:import`, payloadData);
